import type { InputSearchFilter } from "@nosto/nosto-js/client"
import expandMapping from "../expandMapping"
import flattenMapping from "../flattenMapping"
import { NestedFilter } from "../mapping"
import createMapper from "../createMapper"
import filterEncoding from "./filterEncoding"

/**
 * Encodes the query object by converting the `filter` property of the `products` object to an object with key-value pairs.
 * @example
 * products.filter.0.field=skus.customFields.size&products.filter.0.value.0=10 to products.filter.skus.customFields.size=10,15
 * customUrlMappings: [
 *    compressFilterParameters
 * ]
 *
 * @hidden
 */
export default createMapper<{ filter?: InputSearchFilter[] }, { filter?: NestedFilter }>({
    encode({ filter, ...rest }, options) {
        if (!filter) return rest
        const compressedFilter = filter.reduce<Record<string, string>>((acc, filterEntry) => {
            return { ...acc, ...filterEncoding.encode(filterEntry, options) }
        }, {})
        const expandedFields = expandMapping(compressedFilter)
        return { ...rest, filter: expandedFields }
    },
    decode({ filter, ...rest }, options) {
        if (!filter) return rest
        const compressedFields = flattenMapping(filter)
        const expandedFilter = Object.entries(compressedFields).map(([field, value]) =>
            filterEncoding.decode(field, value, options)
        )
        return { ...rest, filter: expandedFilter }
    }
})
